// useLogout — the sign-out mutation, shared by the account menu + the mobile
// nav drawer.
//
// POST /auth/logout, then Layer 3 cross-tab fan-out (ADR-003 §Revocation): the
// sibling tabs converge in ~0s via the `logout` broadcast instead of waiting up
// to 60s for their /me poll to surface a 401. Local clear + redirect to /login.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../lib/apiClient.js';
import { broadcastAuth } from '../lib/authBroadcast.js';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiClient.post('/auth/logout'),
    onSettled: () => {
      broadcastAuth({ type: 'logout' });
      queryClient.clear();
      navigate('/login', { replace: true });
    },
  });
}
